var exports = {
  "WC": "xaf9ae18d--2e5804--department-link-wrapper",
  "bZ": "xaf9ae18d--2e5804--rate-mark-wrapper",
  "a_": "xaf9ae18d--2e5804--terms",
  "FS": "xaf9ae18d--2e5804--term-item",
  "fg": "xaf9ae18d--2e5804--term-item--done",
};

module.exports = exports;
